/**
 * ルートパス定数（SSOT）
 * フロントエンドのルーティングとURL生成で使用
 */

/** 公開イベントページのルートパターン（React Router用） */
export const PUBLIC_EVENT_ROUTE = 'p/events/:eventId';

/** 公開イベントページのパスを生成 */
export const publicEventPath = (eventId: string) => `/p/events/${eventId}`;

/**
 * 共有用の公開イベントページのパス（?v=<イベントの version> 付き）。
 * LINE などの SNS はリンクのプレビューを URL ごとに覚えるので、編集して version が上がった後に
 * 共有し直すと別の URL になり、新しい日時やタイトルのプレビューが出る（docs/features/og-share-page.md）
 */
export const shareEventPath = (eventId: string, version: number) =>
  `${publicEventPath(eventId)}?v=${version}`;

/** 更新履歴トップ */
export const CHANGELOG_PATH = '/changelog';

/** 更新履歴（月別詳細）のルートパターン（React Router用） */
export const CHANGELOG_MONTH_ROUTE = 'changelog/:month';

/** 更新履歴（月別詳細）のパスを生成。month は 'YYYY-MM' */
export const changelogMonthPath = (month: string) => `${CHANGELOG_PATH}/${month}`;
